<template>
	<div>
		<v-card flat>
			<!-- <v-toolbar card prominent>
       
 			<v-spacer></v-spacer>
			 
            <v-btn v-show="!isEdit" small class="info" @click="setIsEdit(true)">
              <v-icon>edit</v-icon>  Edit Discussion Points
            </v-btn>
			 <v-btn v-show="isEdit" small class="success" @click="setIsEdit(false)">
              <v-icon>check</v-icon>  Finished Editing
            </v-btn>

          </v-toolbar> -->

			<v-card-text>
				<div v-if="isEdit" class="text-xs-left">
					<v-btn flat class="warning" small @click="onAddGroupClick()"> <v-icon left>add</v-icon>Add New Grouping </v-btn>
				</div>

				<div v-for="group in groups" :key="group">
					<div class="text-xs-left group-heading">
						<performance-review-group :group="group" :existing-groups="existingGroups" :allow-edit="isEdit" @onGroupChanged="onGroupChanged" @onGroupRemoved="onGroupRemoved" />
					</div>

					<div v-for="category in getGroupItems(group)" :key="category.id">
						<div class="text-xs-left">
							<h4 v-if="category.category !== 'N/A' && category.category !== null" class="category-heading">
								{{ category.category }}
							</h4>
						</div>
						<div v-for="item in category.items" :key="item.id" class="item">
							<performance-review-item :item="item" :allow-edit="isEdit" @onSetIsEdit="onSetItemIsEdit" @onItemChanged="onItemChanged" @onItemRemoved="onItemRemoved" />
						</div>
					</div>

					<div v-if="isEdit" class="text-xs-left">
						<v-btn class="info" small @click="onAddItemClick(group)"> <v-icon left>add</v-icon>Add Discussion Point </v-btn>
					</div>
				</div>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';
	import performanceReviewItemsMixin from '@/mixins/performanceReviewItemsMixin';
	import PerformanceReviewItem from '@/components/performanceReview/PerformanceReviewItem';
	import PerformanceReviewGroup from '@/components/performanceReview/PerformanceReviewGroup';

	export default {
		props: {
			reviewItems: {
				required: false,
				type: Array
			},
			edit: {
				required: false,
				type: Boolean,
				default: true
			}
		},
		components: {
			PerformanceReviewItem,
			PerformanceReviewGroup
		},
		data() {
			return {
				form: {
					reviewItems: this.reviewItems // JSON.parse(JSON.stringify(this.reviewItems))
				},
				itemsSorted: [],
				groups: [],
				mostRecentNewGroup: '6ce74785-5290-496d-be04-de0f6e58d91e',
				isEdit: this.edit
			};
		},
		created() {
			if (this.form.reviewItems.length === 0) {
				this.form.reviewItems.push({
					id: this.newGuid(),
					category: null,
					item: null,
					type: 99,
					outcomes: [],
					group: null,
					rankType: 0
				});
			}

			this.getGroups();
			this.sortItems();
		},
		mixins: [typeFriendlyMixin, performanceReviewItemsMixin],
		computed: {
			existingGroups() {
				return this.groups.filter(x => x !== this.mostRecentNewGroup);
			}
		},
		methods: {
			setIsEdit(val) {
				this.isEdit = val;
				// this.$emit('onSetIsEditingItemBuilder', this.isEdit);
			},
			onSetItemIsEdit(val) {},
			onSetGroupIsEdit(val) {},
			getGroupItems(group) {
				let found = this.itemsSorted.find(x => x.group === group);

				if (found && found.items.length > 0) {
					return found.items;
				}
				return [];
			},
			onItemChanged(item) {
				let found = this.form.reviewItems.find(x => x.id === item.id);
				Object.assign(found, item);
			},
			onItemRemoved(item) {
				const index = this.form.reviewItems.indexOf(this.form.reviewItems.find(x => x.id == item.id));
				if (index > -1) {
					this.form.reviewItems.splice(index, 1);
					this.sortItems();
				}
			},
			onAddItemClick(group) {
				this.form.reviewItems.push({
					category: null,
					group: group,
					id: this.newGuid(),
					item: null,
					outcomes: [],
					rankType: 0,
					type: 99
				});
				this.sortItems();
			},
			onGroupChanged(group) {
				let index = this.groups.indexOf(this.groups.find(x => x === group.original));
				this.groups[index] = group.updated;

				for (let i = 0; i < this.form.reviewItems.length; i++) {
					if (this.form.reviewItems[i].group === group.original) {
						this.form.reviewItems[i].group = group.updated;
					}
				}

				if (group.original === null) {
					this.groups.unshift(null);
				}

				this.sortItems();
			},
			onGroupRemoved(group) {
				const index = this.groups.indexOf(this.groups.find(x => x == group.original));
				if (index > -1) {
					this.groups.splice(index, 1);
				}

				for (let i = 0; i < this.form.reviewItems.length; i++) {
					if (this.form.reviewItems[i].group === group.original) {
						this.form.reviewItems[i].group = null;
					}
				}

				if (!this.groups.includes(null)) {
					this.groups.unshift(null);
				}

				this.sortItems();
			},
			onAddGroupClick() {
				let newGroupBaseName = 'New Group';
				let newGroupName = newGroupBaseName;
				let i = 2;
				while (this.groups.some(x => x === newGroupName)) {
					newGroupName = `${newGroupBaseName} [${i}]`;
					i += 1;
				}
				this.groups.unshift(newGroupName);
				this.mostRecentNewGroup = newGroupName;

				this.sortItems();
			},
			sortItems() {
				this.itemsSorted = this.getReviewItemsSorted(this.form.reviewItems, 'group', 'category');
			},
			getGroups() {
				this.groups = [...new Set(this.form.reviewItems.map(item => item.group))];
			}
		}
	};
</script>

<style scoped>
	.group-heading {
		margin-bottom: 20px;
		margin-top: 20px;
	}
	.v-divider {
		margin-bottom: 20px;
	}
</style>
